// Auto-generated file - do not edit manually
export const LOCALE_HASH = 'edbb21a4';
